import React, { useEffect, useRef, useState } from "react";
import ImageSection from "../ImageSection";
import { withTranslation, useTranslation } from "react-i18next";
import "./DigitalTools.css";

/* ── Iconos SVG por feature ── */
const FEATURE_ICONS = {
  1: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
    </svg>
  ),
  2: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/>
      <path d="M13.73 21a2 2 0 01-3.46 0"/>
    </svg>
  ),
  3: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 20V10M12 20V4M6 20v-6"/>
    </svg>
  ),
  4: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="5" y="2" width="14" height="20" rx="2"/>
      <path d="M12 18h.01"/>
    </svg>
  ),
};

/* ── Feature item individual ── */
const FeatureItem = ({ index, data, t, visible }) => (
  <div
    className="xAgro-dt-feature"
    data-visible={visible}
    style={{ transitionDelay: `${index * 80 + 250}ms` }}
  >
    <div className="xAgro-dt-feature-icon">
      {FEATURE_ICONS[index]}
    </div>
    <div className="xAgro-dt-feature-body">
      <h4 className="xAgro-dt-feature-title">
        {t(`${data}.feature_${index}_title`)}
      </h4>
      <span className="xAgro-dt-feature-desc">
        {t(`${data}.feature_${index}_content`)}
      </span>
    </div>
  </div>
);

/* ── Componente principal ── */
const DigitalTools = ({ reverse, data, id }) => {
  const [t] = useTranslation("common");
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  const title = t(`${data}.title`);
  const subtitle = t(`${data}.subtitle`);
  const badge = t(`${data}.badge`, { defaultValue: subtitle });

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.12 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      className="xAgro-dt-section"
      id={id}
      ref={sectionRef}
    >
      <div className="xAgro-dt-wrapper">
        <div className={`row xAgro-dt-row ${reverse ? 'xAgro-dt-row--reverse' : ''}`}>

          {/* ── Columna de contenido ── */}
          <div className="col-12 col-md-6 xAgro-dt-content">

            {/* Badge */}
            <div
              className="xAgro-dt-badge"
              data-visible={visible}
            >
              <span className="xAgro-dt-badge-dot" />
              {badge}
            </div>

            {/* Título */}
            <h1
              className="xAgro-dt-title"
              data-visible={visible}
            >
              {title}
            </h1>

            {/* Features list */}
            <div className="xAgro-dt-features">
              {[1, 2, 3, 4].map((i) => (
                <FeatureItem
                  key={i}
                  index={i}
                  data={data}
                  t={t}
                  visible={visible}
                />
              ))}
            </div>
          </div>

          {/* ── Columna de imagen ── */}
          <div className="col-12 col-md-6 xAgro-dt-image-col">
            <div
              className="xAgro-dt-image-container"
              data-visible={visible}
              data-reverse={reverse}
            >
              <div className="xAgro-dt-image-glow" />
              <ImageSection data={data} />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default withTranslation("common")(DigitalTools);